import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DataLayer } from '../../Models/dataLayer';
import { DatosGenerales } from '../../Models/datosGenerales';
import { getSessionId } from '../../helpers/storageUtils';
import { selectData } from '../../storage/Lead/data.selectors';
import { WindowReferenceService } from '../Window/window-reference.service';

@Injectable({
  providedIn: 'root',
})
export class DataLayerService {
  private store = inject(Store);
  private window;
  sessionId: string;
  datosGenerales: DatosGenerales | null = null;
  datosGenerales$: Observable<DatosGenerales | null>;

  constructor(private _windowRef: WindowReferenceService) {
    this.window = _windowRef.nativeWindow; // intialise the window to what we get from our window service
    this.sessionId = getSessionId().toString();
    this.datosGenerales$ = this.store.select(selectData);

    this.datosGenerales$.subscribe((data) => {
      this.datosGenerales = data;
    });
  }

  pushDataLayer(data: DataLayer) {
    // Envío de datos al dataLayer
    if (data) this.window.dataLayer.push(data);
  }

  pushDataLayerStepErrorInit(
    ecom_item: 'Pageview' | 'Button' | undefined,
    error_tipo?: string,
    ecom_pantalla?: string,
    ecom_subitem?: string,
  ) {
    // cotizacion pausa
    this.pushDataLayer({
      event: 'ecommerce_step_error', // validado
      ecom_tipo: 'Moto', // validado
      ecom_item, // validado
      ecom_pantalla, // validado
      error_tipo,
      user_id: this.sessionId, // validado
      ...(ecom_subitem !== undefined && { ecom_subitem }),
    });
  }

  pushDataLayerOnerous(
    ecom_item: 'Pageview' | 'Button' | undefined,
    event: string,
    ecom_pantalla: string,
  ) {
    this.pushDataLayer({
      event: event,
      ecom_tipo: 'Moto',
      ecom_item,
      ecom_pantalla: ecom_pantalla,
      user_id: this.sessionId,
      uso_vehiculo: this.datosGenerales?.Lead.use_type || 'Particular',
      zona_circulacion: this.datosGenerales?.Lead.cityName,
      placa: this.datosGenerales?.Lead.plate,
      marca_vehiculo: this.datosGenerales?.LeadResponse?.data?.vehicle?.brand,
      modelo_vehiculo: this.datosGenerales?.LeadResponse?.data?.vehicle?.model,
      cilindraje_vehiculo: this.datosGenerales?.LeadResponse?.data?.vehicle?.cylinder,
    });
  }
}
